import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import usePagination from 'hooks/usePagination';
import { Loading } from 'components';
import { BOARD_QNA_MODULE_NO } from 'data/constants';

import boardService from 'services/board/board-service';
import QnaView from './QnaView';

export function Qna(props) {
  const { langList } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [qnaList, setQnaList] = useState([]);
  // 페이지네이션
  const [searchParams] = useSearchParams();
  const { paginationRequest, setPaginationRequest, paginationResult, setPaginationResult } = usePagination(navigate, searchParams);
  // 상세 페이지 이동 onClick
  const goDetail = (item) => {
    navigate(`/community/qna/view`, { state: { contentNo: item.contentNo } });
  };

  useEffect(() => {
    const fetchQnas = async function () {
      let data = [];

      try {
        const response = await boardService.listContents(BOARD_QNA_MODULE_NO, paginationRequest.pageNumber, paginationRequest.pageSize);

        if (response) {
          if (response.rows) {
            data = response.rows;
          }
          setPaginationResult(response);
        }
      } catch (e) {
        console.error(e);
      }

      setQnaList(data);
    };

    if (paginationRequest) {
      fetchQnas();

      setLoading(false);
    }

    return () => setLoading(true);
  }, [paginationRequest]);

  return (
    <>
      {loading && <Loading />}
      <QnaView
        list={langList.qna}
        qnaList={qnaList}
        goDetail={goDetail}
        paginationRequest={paginationRequest}
        paginationResult={paginationResult}
        setPaginationRequest={setPaginationRequest}
      />
    </>
  );
}
